import {AfterContentInit, Component, ContentChildren, EventEmitter, Input, OnInit, Output, QueryList} from '@angular/core';
import {TabComponent} from '../tab/tab.component';

@Component({
  selector: 'awair-tab-group',
  templateUrl: './tab-group.component.html',
  styleUrls: ['./tab-group.component.scss']
})
export class TabGroupComponent implements OnInit, AfterContentInit {

  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;
  @Output() selectTabIndex: EventEmitter<number> = new EventEmitter();

  get selectedTabIndex(): number {
    return this._selectedTabIndex;
  }

  @Input()
  set selectedTabIndex(value: number) {
    if (value != null && this.tabs != null) {
      this.selectTab(this.tabs.toArray()[value], value);
    }
  }
  private _selectedTabIndex: number;

  constructor() {
  }

  ngOnInit() {
  }

  ngAfterContentInit() {
    // Get all active tabs
    const activeTabs = this.tabs.filter((tab) => tab.active);

    // If there is no active tab set, activate the first
    if (activeTabs.length === 0) {
      this.selectTab(this.tabs.first);
    }
  }

  selectTab(selectedTab: TabComponent, tabIndex?: number) {
    // Deactivate all tabs
    this.tabs.toArray().forEach(tab => tab.active = false);

    // Activate the tab the user has clicked on.
    selectedTab.active = true;
    if (tabIndex != null) {
      this.selectTabIndex.emit(tabIndex);
    }
  }
}
